import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectMarginMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_MARGIN_RESP);
        this.EstAvailableCash = null;
        this.BuyingPowerName = null;
        this.CommissionsByOperationMode = {};
        this.Groups = [];
        this.BuyGroup = new MarginGroup();
        this.SellGroup = new MarginGroup();
        this.ShortSwapInfo = null;
        this.FreeCommission = null;
    }
    get AmountBuy() {
        return this.BuyGroup.Amount;
    }
    // public set AmountBuy (value: number | null) { this.BuyGroup.Amount = value; }
    get AmountSell() {
        return this.SellGroup.Amount;
    }
    // public set AmountSell (value: number | null) { this.SellGroup.Amount = value; }
    get InitMarginBuy() {
        return this.BuyGroup.InitMargin;
    }
    set InitMarginBuy(value) {
        this.BuyGroup.InitMargin = value;
    }
    get InitMarginSell() {
        return this.SellGroup.InitMargin;
    }
    set InitMarginSell(value) {
        this.SellGroup.InitMargin = value;
    }
    get MaintMarginBuy() {
        return this.BuyGroup.MaintMargin;
    }
    set MaintMarginBuy(value) {
        this.BuyGroup.MaintMargin = value;
    }
    get MaintMarginSell() {
        return this.SellGroup.MaintMargin;
    }
    set MaintMarginSell(value) {
        this.SellGroup.MaintMargin = value;
    }
    get SwapBuy() {
        return this.BuyGroup.Swap;
    }
    set SwapBuy(value) {
        this.BuyGroup.Swap = value;
    }
    get SwapSell() {
        return this.SellGroup.Swap;
    }
    set SwapSell(value) {
        this.SellGroup.Swap = value;
    }
    get StocksOrdersReqBuy() {
        return this.BuyGroup.StocksOrdersReq;
    }
    set StocksOrdersReqBuy(value) {
        this.BuyGroup.StocksOrdersReq = value;
    }
    get StocksOrdersReqSell() {
        return this.SellGroup.StocksOrdersReq;
    }
    set StocksOrdersReqSell(value) {
        this.SellGroup.StocksOrdersReq = value;
    }
}
export class MarginGroup {
    constructor() {
        this.AfterTradeFunds = null;
        this.AfterTradeMargin = null;
        this.Amount = null;
        this.AvailableFunds = null;
        this.Cash = null;
        this.ImpactOnFunds = null;
        this.ImpactOnMargin = null;
        this.InitMargin = null;
        this.MaintMargin = null;
        this.Swap = null;
        this.StocksOrdersReq = null;
        this.TotalFee = null;
        this.OffMarketEnabled = null;
        this.EstAvailableCash = null;
    }
}
export class CommissionGroup {
    constructor() {
        this.CommissionType = null;
        this.OperationType = null;
        this.Amount = null;
        this.CurrencyId = null;
    }
}
